<template>
  <modal
    :isShow.sync="linkDialog"
    title="直播链接"
    :isShowBtn="[false, false]"
    :width="'423px'"
  >
    <div class="content flexs middle-a dialog-btns middle-a">
      <el-input
        class="dialog-input"
        v-model="url"
        placeholder="请输入直播链接"
      ></el-input>
      <el-button class="color" type="text" size="small">
        <a :href="url" target="_blank">打开</a>
      </el-button>
      <el-button type="text" size="small" @click="copyUrl(url)">
        复制
      </el-button>
    </div>
  </modal>
</template>

<script>
import modal from "@/components/modal";
import { copyUrl } from "@/utils/tools";

export default {
  name: "liveLink",
  props: ["mUrl"],
  data() {
    return {
      linkDialog: false,
    };
  },
  computed: {
    url: {
      get() {
        return this.mUrl;
      },
      set(val) {
        this.$emit("update:mUrl", val);
      },
    },
  },
  methods: {
    copyUrl(content) {
      copyUrl(content, this);
    },
  },
  components: {
    modal,
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 26px 25px 72px 26px;
  .color {
    margin-left: 24px;
  }
  .dialog-input {
    width: 282px;
  }
  :deep(.el-input__inner) {
    height: 32px;
  }
}
</style>
